import { useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import * as ViewSelectors from '../../redux/selectors/view'
import { clearAlert } from '../../redux/slices/view'
import { useHistory } from 'react-router'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Modal from '@ui-components-3/ui/lib/components/Modal'

const Alert = withReactContent(Swal)

const ConnectedAlert = (props) => {
  const dispatch = useDispatch()
  const alertProps = useSelector(ViewSelectors.getAlert)
  const history = useHistory()
  const { isSimple, isAlert, type, title, body, yesContent, noContent } = alertProps

  const handleConfirm = useCallback(() => {
    if (props.onConfirm) props.onConfirm()
    dispatch(clearAlert())
    if (alertProps.confirmRoute) history.push(alertProps.confirmRoute)
  }, [props, alertProps, dispatch, history])

  const handleCancel = useCallback(() => {
    if (props.onCancel) props.onCancel()
    dispatch(clearAlert())
    if (alertProps.cancelRoute) history.push(alertProps.cancelRoute)
  }, [props, alertProps, dispatch, history])

  const onClose = useCallback(() => {
    dispatch(clearAlert())
  }, [dispatch])

  // Always call useEffect, regardless of isSimple
  useEffect(() => {
    if (isAlert) {
      Alert.fire({
        icon: type,
        title,
        html: body,
        width: '450px',
        showCancelButton: true,
        reverseButtons: true,
        buttonsStyling: false,
        allowOutsideClick: false,
        customClass: {
          confirmButton: 'btn-small btn-primary',
          cancelButton: 'btn-small btn-neutral-outlined mr-xs',
          htmlContainer: 'typography-body-l text-neutral font-light mb-0',
          title: 'typography-body-xxl text-neutral font-semibold',
        },
      }).then(({ isConfirmed, isDismissed }) => {
        if (isConfirmed) handleConfirm()
        if (isDismissed) handleCancel()
      })
    }
  }, [isAlert, type, title, body, handleConfirm, handleCancel])

  if (isSimple) {
    return (
      <Modal
        opened
        label={title}
        onClose={onClose}
        footer={() => (
          <>
            <button type="button" className="btn btn-neutral-outlined" onClick={handleCancel}>
              {noContent}
            </button>
            <button type="button" className="btn btn-neutral" onClick={handleConfirm}>
              {yesContent}
            </button>
          </>
        )}
      >
        <p className="typography-body-l">{body}</p>
      </Modal>
    )
  }

  return null
}

ConnectedAlert.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
}

export default ConnectedAlert
